import axios from "axios";
import * as actions from "./actionsTypes";
import * as actionsCompetencia from "../Overview/actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import FormEvalCompetenciaServices from "./eval_form_competency.services";
import EvaluationMonitorServices from "../EvaluationMonitor/EvaluationMonitor.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getFormEvalCompetencias = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_FORMULARIO_COMPETENCIA,
      payload: true,
    });
    const resp = await FormEvalCompetenciaServices.getFormEvalCompetencias(
      filters
    );
    dispatch({
      type: actions.GET_FORMULARIO_COMPETENCIA,
      payload: resp.data, // agregar .data
    });
    // console.log("data de form", resp.data)
    dispatch({
      type: actions.FORMULARIO_COMPETENCIA_FALLA,
      payload: null,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          case 403:
            if (ex.response.data && ex.response.data.detail) {
              message = ex.response.data.detail;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.FORMULARIO_COMPETENCIA_FALLA,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADER_FORMULARIO_COMPETENCIA,
      payload: false,
    });
  }
};

export const getFormEvalCompeteciaById = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_FORMULARIO_COMPETENCIA,
      payload: true,
    });
    const resp = await FormEvalCompetenciaServices.getFormEvalCompetencia(id);

    // console.log('Data preguntas => ', resp);

    dispatch({
      type: actions.GET_FORMULARIO_COMPETENCIA,
      payload: resp.data,
    });
    dispatch({
      type: actions.FORMULARIO_COMPETENCIA_FALLA,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORMULARIO_COMPETENCIA_FALLA,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADER_FORMULARIO_COMPETENCIA,
      payload: false,
    });
  }
};

export const saveFormEvalCompetencia =
  (req, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADER_FORMULARIO_COMPETENCIA,
        payload: true,
      });
      const resp = await FormEvalCompetenciaServices.saveFormEvalCompetencia(
        req
      );
      const { data, count } = getState().formEvalCompetency.formEvalCompetency;
      dispatch({
        type: actions.GET_FORMULARIO_COMPETENCIA,
        payload: {
          count: count + 1,
          data: [...data, resp.data],
        },
      });
      dispatch({
        type: actions.FORM_FORMULARIO_COMPETENCIA_FAIL,
        payload: "",
      });
      setShowModal(false);
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = ex.response.data;
              break;
            case 404:
              if (ex.response.data && ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.notFound;
              }
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 403:
              if (ex.response.data && ex.response.data.detail) {
                message = ex.response.data.detail;
              } else {
                message = messages.notFound;
              }
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FORMULARIO_COMPETENCIA_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADER_FORMULARIO_COMPETENCIA,
        payload: false,
      });
    }
  };

export const editFormEvalCompetencia =
  (req, evalFormCompetency, tipo_eval) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADER_FORMULARIO_COMPETENCIA,
        payload: true,
      });
      const resp = await FormEvalCompetenciaServices.editFormEvalCompetencia(
        evalFormCompetency.id,
        req
      );
      const { overviews } = getState().overview;
      overviews.comentario_evaluador = req.comentario_evaluador;
      dispatch({
        type: actions.GET_FORMULARIO_COMPETENCIA,
        payload: resp.data,
      });
      dispatch({
        type: actionsCompetencia.GET_OVERVIEW,
        payload: {
          overviews: overviews,
        },
      });
      dispatch({
        type: actions.FORM_FORMULARIO_COMPETENCIA_FAIL,
        payload: "",
      });
      if (tipo_eval==="0°" && (!evalFormCompetency.comentario_evaluador||evalFormCompetency.comentario_evaluador!=="") && (!evalFormCompetency.comentario_evaluado||evalFormCompetency.comentario_evaluado!=="")) {
        const _data = {
          data: [
            {
              id: evalFormCompetency.id,
              tipo_mensaje: "Jefe: Colaborador realizo su autoevaluación",
            },
          ],
        };
        await EvaluationMonitorServices.mailSendEvaluationMonitor(_data);
        toastr.success(messages.correoEnviado, "", {
          progressBar: true,
          rtl: true,
        });
      };
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              if (ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                toastr.info(ex.response.data);
              }
              break;
            case 404:
              if (ex.response.data && ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.notFound;
              }
              break;
            default:
              message = messages.errorMessage;
              break;
          }
        } else {
          message = messages.networkError;
        }
      } else {
        message = messages.applicationError;
      }
      dispatch({
        type: actions.FORMULARIO_COMPETENCIA_FALLA,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADER_FORMULARIO_COMPETENCIA,
        payload: false,
      });
    }
  };

export const deleteFormEvalCompetencia =
  (id, index) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADER_FORMULARIO_COMPETENCIA,
        payload: true,
      });
      await FormEvalCompetenciaServices.deleteFormEvalCompetencia(id);
      const { data, count } = getState().formEvalCompetency.formEvalCompetency;
      let _data = data.slice();
      _data.splice(index, 1);
      dispatch({
        type: actions.GET_FORMULARIO_COMPETENCIA,
        payload: {
          data: _data,
          count: count - 1,
        },
      });
      dispatch({
        type: actions.FORMULARIO_COMPETENCIA_FALLA,
        payload: "",
      });
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = ex.response.data.mensaje;
              break;
            case 404:
              if (ex.response.data && ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.notFound;
              }
              break;
            default:
              message = messages.errorMessage;
              break;
          }
        } else {
          message = messages.networkError;
        }
      } else {
        message = messages.applicationError;
      }
      dispatch({
        type: actions.FORMULARIO_COMPETENCIA_FALLA,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADER_FORMULARIO_COMPETENCIA,
        payload: false,
      });
    }
  };

export const sendNotifications =
  (req, id, reqEvaluation) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADER_FORMULARIO_COMPETENCIA,
        payload: true,
      });
      await FormEvalCompetenciaServices.sendNotifications(req);
      await FormEvalCompetenciaServices.editFormEvalCompetencia(id, {
        enviada: true,
      });
      if (reqEvaluation) {
        await FormEvalCompetenciaServices.sendOverviewNotifications(
          reqEvaluation
        );
      }
      toastr.success(messages.correoEnviado, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              if (ex.response.data && ex.response.data.length > 0) {
                message = ex.response.data[0];
              } else {
                message = ex.response.data;
              }
              break;
            case 404:
              if (ex.response.data && ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.notFound;
              }
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 403:
              if (ex.response.data && ex.response.data.detail) {
                message = ex.response.data.detail;
              } else {
                message = messages.notFound;
              }
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      toastr.info(message, "", {
        progressBar: true,
        rtl: true,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADER_FORMULARIO_COMPETENCIA,
        payload: false,
      });
    }
  };

export const sendOverviewNotifications =
  (reqEvaluation) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADER_FORMULARIO_COMPETENCIA,
        payload: true,
      });
      await FormEvalCompetenciaServices.sendOverviewNotifications(
        reqEvaluation
      );
      toastr.success(messages.correoEnviado, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              if (ex.response.data && ex.response.data.length > 0) {
                message = ex.response.data[0];
              } else {
                message = ex.response.data;
              }
              break;
            case 404:
              if (ex.response.data && ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.notFound;
              }
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 403:
              if (ex.response.data && ex.response.data.detail) {
                message = ex.response.data.detail;
              } else {
                message = messages.notFound;
              }
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      toastr.info(message, "", {
        progressBar: true,
        rtl: true,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADER_FORMULARIO_COMPETENCIA,
        payload: false,
      });
    }
  };
